import { useParams, Link } from "react-router-dom";

import facewash from "../images/facewash.jpg";
import shampoo from "../images/shampoo.jpg";
import cream from "../images/cream.jpg";
import aloegel from "../images/aloegel.jpg";
import acnecream from "../images/acnecream.jpg";

function ProductDetails({ products, addToCart }) {
  const { id } = useParams();

  const product = products.find((item) => item.id === parseInt(id));

  const imageMap = {
    "facewash.jpg": facewash,
    "shampoo.jpg": shampoo,
    "cream.jpg": cream,
    "aloegel.jpg": aloegel,
    "acnecream.jpg": acnecream,
  };

  if (!product) {
    return <h2 style={{ padding: "30px" }}>Product not found</h2>;
  }

  const productImage =
    product.image && product.image.startsWith("http")
      ? product.image
      : imageMap[product.image];

  return (
    <div
      style={{
        padding: "40px 30px",
        fontFamily: "Arial, sans-serif",
        background: "#f7f8fa",
        minHeight: "100vh",
      }}
    >
      <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
        <Link
          to="/"
          style={{
            display: "inline-block",
            marginBottom: "25px",
            textDecoration: "none",
            color: "#16a34a",
            fontWeight: "bold",
            fontSize: "15px",
          }}
        >
          ← Back to Products
        </Link>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "40px",
            background: "white",
            borderRadius: "20px",
            padding: "35px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "#f3f4f6",
              borderRadius: "16px",
              minHeight: "420px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "25px",
            }}
          >
            {productImage ? (
              <img
                src={productImage}
                alt={product.name}
                style={{
                  maxWidth: "100%",
                  maxHeight: "360px",
                  objectFit: "contain",
                }}
              />
            ) : (
              <span style={{ color: "#9ca3af", fontSize: "16px" }}>
                No Image
              </span>
            )}
          </div>

          <div>
            <p
              style={{
                color: "#16a34a",
                fontWeight: "bold",
                margin: "0 0 12px 0",
                fontSize: "14px",
                letterSpacing: "0.5px",
              }}
            >
              {product.category}
            </p>

            <h1
              style={{
                margin: "0 0 16px 0",
                color: "#111827",
                fontSize: "36px",
                lineHeight: "1.2",
              }}
            >
              {product.name}
            </h1>

            <p
              style={{
                color: "#4b5563",
                fontSize: "16px",
                lineHeight: "1.7",
                marginBottom: "24px",
              }}
            >
              {product.description}
            </p>

            <div
              style={{
                background: "#f9fafb",
                border: "1px solid #e5e7eb",
                borderRadius: "14px",
                padding: "20px",
                marginBottom: "24px",
              }}
            >
              <p
                style={{
                  margin: "0 0 8px 0",
                  color: "#6b7280",
                  fontSize: "14px",
                }}
              >
                Price
              </p>

              <h2
                style={{
                  margin: 0,
                  color: "#111827",
                  fontSize: "32px",
                }}
              >
                ₹{product.price}
              </h2>
            </div>

            <button
              onClick={() => addToCart(product)}
              style={{
                background: "linear-gradient(135deg, #22c55e, #16a34a)",
                border: "none",
                padding: "14px 24px",
                color: "white",
                borderRadius: "10px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "16px",
                minWidth: "180px",
              }}
            >
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductDetails;